(() => {
    'use strict';

    // Carried on the add button by the categories card, so the server stays the one place the default
    // category colours are written down. See CategoryColors.
    const CATEGORY_COLOR_FALLBACK = '#FFFFFF';

    /** The colour a category added by this button gets, by its position in the list. */
    const categoryColorForPosition = (button, position) => {
        const palette = String($(button).data('category-colors') || '').split(',').filter(Boolean);
        if (palette.length === 0) {
            return CATEGORY_COLOR_FALLBACK;
        }
        return palette[position % palette.length];
    };

    const sortComments = (widget, sortBy, sortOrder = 'desc') => {

        const sortField = {
            'likes': 'number_of_likes',
            'points': 'point_voting_results.total_sum_of_points',
            'reactions': 'number_of_reactions',
            'original': ''
        }
        if (sortField[sortBy] === undefined) {
            return;
        }
        widget.find('.sort-comments-btn').prop('disabled', false);
        widget.find('.sort-comments-by-' + sortBy + '-btn').prop('disabled', true);
        widget.dataAndAttr('comments-sort-order', sortBy);
        const lister = widget.find('.comments.howspace-lister');
        lister.dataAndAttr('sort-by', sortField[sortBy]);
        lister.dataAndAttr('sort-order', sortOrder);

        howspace.whatsNew.destroy(lister);
        howspace.components.lister.reload(lister);

        showHideSortingInfoPanel(widget);
    };

    const showHideSortingInfoPanel = (widget) => {
        const keyTranslations = {
            'likes': howspace.translate('discussion_sort_comments_by_likes'),
            'points': howspace.translate('discussion_sort_comments_by_points'),
            'reactions': howspace.translate('discussion_sort_comments_by_reactions'),
            'original': howspace.translate('discussion_sort_comments_by_original')
        };

        // Sorting info panel.
        const sortedInfo = widget.find('.comments-sorted-info');
        const sortBy = widget.data('comments-sort-order') || widget.data('comments-default-sort-order');
        sortedInfo.find('.sorted-by-item .sort-value').html(keyTranslations[sortBy]);

        if (
            sortBy !== 'original' ||
            widget.data('comments-sort-order') &&
            widget.data('comments-sort-order') !== widget.data('comments-default-sort-order')
        ) {
            sortedInfo.removeClass('d-none');
        } else {
            sortedInfo.addClass('d-none');
        }

        if (widget.data('comments-sort-order') && widget.data('comments-sort-order') !== widget.data('comments-default-sort-order')) {
            widget.find('.save-current-comments-sort-btn').removeClass('d-none');
        } else {
            widget.find('.save-current-comments-sort-btn').addClass('d-none');
        }
    };

    const saveCurrentSort = (widget) => {
        const currentSortBy = widget.data('comments-sort-order') || widget.data('comments-default-sort-order');
        const dataPayload = {
            sort_by: currentSortBy,
            sort_order: currentSortBy === 'original'
                ? (widget.data('latest-comment-at-top') ? 'desc' : 'asc')
                : 'desc',
        };

        real.ajax.json(howspace.widgets.getApiUrl(widget), {
            type: 'POST',
            data: JSON.stringify(dataPayload),
        });
    };

    const moveComment = (widget, e) => {
        const btn = $(e.target);
        const comment = btn.closest('.comment');

        const dataPayload = {
            _action: 'move',
            discussion: btn.data('widget-id')
        };

        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/comment/' + comment.data('id'), {
            type: 'POST',
            data: JSON.stringify(dataPayload),
        });
    };

    const duplicateComment = (widget, e) => {
        const btn = $(e.target);
        const comment = btn.closest('.comment');

        const dataPayload = {
            _action: 'duplicate',
            discussion: btn.data('widget-id')
        };

        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/comment/' + comment.data('id'), {
            type: 'POST',
            data: JSON.stringify(dataPayload),
        });
    };

    // Init event handlers globally for all discussion widgets.
    howspace.commentsTrait.attachEventHandlers('discussion');

    const saveFeedback = (dataPayload, callback) => {
        real.ajax.json(real.baseUri + '/api/ai/prompt/feedback', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: (response) => {
                if (callback) {
                    callback(response);
                }
            }
        });
    }

    const initPromptResponseFeedbackModal = (modal) => {
        modal = $(modal);
        const submitBtn = modal.find('.submit-btn');
        modal.on('click', '.submit-btn', () => {
            real.button.loading(submitBtn, modal.find('.modal-body'));
            const dataPayload = real.form.getDataPayload(modal.find('.modal-body'));
            const widget = $('#widget-' + modal.data('widget-id'));
            const promptResponseWrapper = widget.find('.prompt-response-wrapper');
            dataPayload.query_id = promptResponseWrapper.data('prompt-id');
            saveFeedback(dataPayload, () => {
                real.button.reset(submitBtn, modal.find('.modal-body'));
                real.notification.show(howspace.translate('discussion_ai_prompt_feedback_thank_you_notification'), 'success');
                setTimeout(() => {
                    real.notification.hide();
                }, 5000);
                const feedbackWrapper = promptResponseWrapper.find('.feedback-wrapper');
                howspace.animate(feedbackWrapper, 'slideUp', 'fast', () => {
                    feedbackWrapper.addClass('d-none');
                });
            });
        });
    }

    const checkAndShowTheAnonymousMessage = (modal, widget) => {
        modal.on(howspace.components.lister.LIST_ITEMS_LOADED, e => {
            if (widget.data('is-permanently-anonymous')) {
                modal.find('.howspace-lister-items .user').addClass('d-none');
                modal.find('.howspace-lister-items .user').first().removeClass('d-none');
            }
        });
    }

    const initUsersWhoHaveCommentedModal = (modal, modalOpener) => {
        modal = $(modal);

        const widget = $(modalOpener).closest('.widget');
        if (widget.length === 0) {
            return;
        }

        checkAndShowTheAnonymousMessage(modal, widget);
    };

    const initUsersWhoHaveNotCommentedModal = (modal, modalOpener) => {
        modal = $(modal);

        const widget = $(modalOpener).closest('.widget');
        if (widget.length === 0) {
            return;
        }
        checkAndShowTheAnonymousMessage(modal, widget);
    };

    const postPrompt = (widget, prompt) => {
        real.ajax.json(real.baseUri + '/api/ai/prompt/widget', {
            type: 'POST',
            data: JSON.stringify({
                context: {
                    'widget_type': widget.data('widget-type'),
                    'widget_id': widget.data('widget-id')
                },
                prompt: prompt
            }),
            success: () => {
                howspace.aiGen.setPromptTimeout(widget);
            },
            error: () => {
                real.notification.show(howspace.translate('widget_prompt_failed'), 'danger');
                real.button.reset(widget.find('.prompt-btn'), widget.find('.prompt-container'));
            }
        });
    };

    const initAddCategoryModal = (modal, modalOpener) => {
        modal = $(modal);
        const widget = $(modalOpener).closest('.widget');

        modal.find('.add-category-btn').on('click', e => {
            const sortableList = modal.find('.howspace-sortable-list');
            const category = howspace.components.sortableList.addItem(sortableList);
            const color = categoryColorForPosition(e.currentTarget, sortableList.find('.category').length - 1);
            howspace.components.colorPicker.setColor(category.find('.howspace-color-picker'), color);
            category.find('input').trigger('focus');
        });

        modal.find('.save-button').on('click', () => {
            const dataPayload = real.form.getDataPayload(modal);
            dataPayload.categories = [];
            modal.find('.category:not(.deleted)').each(function () {
                dataPayload.categories.push(real.form.getDataPayload($(this)));
            });

            real.ajax.json(howspace.widgets.getSourceApiUrl(widget), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.components.modal.close(modal);
                }
            });
        });

        modal.find('.add-category-btn').trigger('click');
    };

    const initAiCategorizeModal = (modal, modalOpener) => {
        initAddCategoryModal(modal, modalOpener);

        modal = $(modal);
        modal.find('.howspace-loader').removeClass('d-none');
        modal.find('.categories').addClass('d-none');
        real.button.loading(modal.find('.btn-success'));

        const widget = $(modalOpener).closest('.widget');

        const dataPayload = {
            context: {
                'widget_type': widget.data('widget-type'),
                'widget_id': widget.data('widget-id')
            }
        };

        real.ajax.json(real.baseUri + '/api/ai/prompt/create-categories', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: () => {
                howspace.aiGen.setPromptTimeout(widget);
            },
            error: () => {
                real.notification.show(howspace.translate('discussion_ai_create_categories_failed'), 'danger');
                howspace.aiGen.clearPromptTimeout(widget);
            }
        });
    };

    const initAutoGenerateContentModal = (modal, modalOpener) => {
        modal = $(modal);
        modal.find('.start-content-generation-btn').on('click', () => {
            let dataPayload = real.form.getDataPayload(modal);
            const widget = $(modalOpener).closest('.widget');
            dataPayload = Object.assign(dataPayload, {
                    'widget_type': widget.data('widget-type'),
                    'widget_id': widget.data('widget-id')
                }
            );
            real.button.loading(modal.find('.start-content-generation-btn'), modal.find('.modal-body'));
            real.ajax.json(real.baseUri + '/api/ai/generate-content/start', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.components.modal.close(modal);
                    real.notification.show(howspace.translate('discussion_ai_auto_content_creation_started'), 'info');
                },
                error: () => {
                    real.notification.show(howspace.translate('discussion_ai_auto_content_creation_failed'), 'danger');
                    real.button.reset(modal.find('.start-content-generation-btn'), modal.find('.modal-body'));
                }
            });
        });
    }

    const checkMode = (widget) => {
        const mode = widget.find('input[data-name="super_chat_mode"]:checked').val();
        const showCategoriesLabel = widget.find('label.show-categories');
        const showCategoriesCheckbox = showCategoriesLabel.find('input[type="checkbox"]');
        const showCategoriesIcon = showCategoriesLabel.find('.show-categories-info-icon');
        if (mode === 'kanban') {
            showCategoriesLabel.addClass('disabled');
            showCategoriesIcon.removeClass('d-none');
            showCategoriesCheckbox.prop('checked', true);
            showCategoriesCheckbox.prop('disabled', true);
            widget.find('.sort-order-input').each(function () {
                const input = $(this);
                const label = input.closest('.howspace-form-label');
                const icon = label.find('.icon');
                if (input.attr('type') === 'checkbox') {
                    input.prop('checked', false);
                }
                input.prop('disabled', true);
                label.addClass('disabled');
                icon.removeClass('d-none');
            });
        } else {
            showCategoriesLabel.removeClass('disabled');
            showCategoriesIcon.addClass('d-none');
            showCategoriesCheckbox.prop('disabled', false);
            widget.find('.sort-order-input').each(function () {
                const input = $(this);
                const label = input.closest('.howspace-form-label');
                const icon = label.find('.icon');
                input.prop('disabled', false);
                label.removeClass('disabled');
                icon.addClass('d-none');
            });
        }
    };

    howspace.widgets.discussion = {
        initView: widget => {
            widget.find('.comment-input').first().addClass('first-comment-input');

            // Component handlers.
            howspace.commentsTrait.attachComponentHandlers(widget);

            // Sort buttons handlers.
            widget.find('.sort-comments-by-likes-btn').on('click', () => {
                sortComments(widget, 'likes', 'desc');
            });

            widget.find('.sort-comments-by-points-btn').on('click', () => {
                sortComments(widget, 'points', 'desc');
            });

            widget.find('.sort-comments-by-original-btn').on('click', () => {
                sortComments(widget, 'original', 'desc');
            });

            widget.find('.sort-comments-by-reactions-btn').on('click', () => {
                sortComments(widget, 'reactions', 'desc');
            });

            widget.find('.save-current-comments-sort-btn').on('click', () => {
                saveCurrentSort(widget);
            });

            widget.find('.restore-comments-sort-btn').on('click', () => {
                if (widget.data('comments-default-sort-order') !== widget.data('comments-sort-order')) {
                    sortComments(widget, widget.data('comments-default-sort-order'), 'desc');
                } else {
                    sortComments(widget, 'original', 'desc');
                }
            });

            // Move and duplicate buttons handlers.
            widget.on('click', '.old-move-comment-btn', e => {
                moveComment(widget, e);
            });

            widget.on('click', '.duplicate-comment-btn', e => {
                duplicateComment(widget, e);
            });

            widget.on('click', '.team-btn', e => {
                const btn = $(e.target);
                const teamSelector = btn.closest('.team-selector');
                let container = null;
                if (teamSelector.closest('.comment-input').length > 0) {
                    container = teamSelector.closest('.comment-input');
                } else if (teamSelector.closest('.reply-input').length > 0) {
                    container = teamSelector.closest('.reply-input');
                }

                const teamAvatar = btn.data('team-avatar-url');
                teamSelector.find('.team-btn').removeClass('active');
                btn.addClass('active');

                const cloneItag = teamSelector.find('.selected-team-btn').find('i').clone();
                // Copy the i tag from the selected team button and concatenate it to clicked button text.
                teamSelector.find('.selected-team-btn').html(cloneItag[0].outerHTML + btn.html());

                widget.find('input[name="team"]').val(btn.data('team-id'));
                if (container) {
                    container.find('.avatar-container img.team-profile').attr('src', teamAvatar + '?format=webp&maxwidth=200');
                }
            });

            // Remove all filters, limit and reload the lister.
            widget.on('click', '.admin-load-more-comments-btn', e => {
                const btn = $(e.target);
                const lister = btn.parent().find('.comments.howspace-lister');
                if (!lister.length) {
                    return;
                }
                btn.addClass('d-none');
                howspace.widgets.clearFilters(widget);
                howspace.whatsNew.destroy(lister);
                lister.dataAndAttr('uri', lister.data('url'));
                howspace.components.lister.reload(lister);
            });

            widget.on(howspace.components.collapse.EXPANDED, '.prompt-container', () => {
                widget.find('.prompt-input').trigger('focus');
            });

            widget.on('click', '.prompt-btn', (e) => {
                const btn = $(e.target);
                if (widget.data('number-of-comments') === 0) {
                    // Don't try to prompt if there are no comments.
                    return;
                }
                const promptInput = widget.find('.prompt-input');

                real.button.loading(btn, widget.find('.prompt-container'));

                postPrompt(widget, promptInput.val().trim());
            });

            widget.find('.prompt-input').on('keydown', (e) => {
                if (e.key === 'Enter') {
                    widget.find('.prompt-btn').trigger('click');
                }
            });

            widget.find('.feedback-sentiment-btn').on('click', (e) => {
                const btn = $(e.target);
                btn.closest('.btn-group').find('.feedback-sentiment-btn').removeClass('active');
                real.button.loading(btn, widget.find('.prompt-response-wrapper'));

                // Save the sentiment.
                const dataPayload = {
                    query_id: widget.find('.prompt-response-wrapper').data('prompt-id'),
                    feedback_sentiment: btn.data('sentiment')
                };
                saveFeedback(dataPayload, function () {
                    btn.addClass('active');
                    real.button.reset(btn, widget.find('.prompt-response-wrapper'));
                });
            });

            widget.find('.copy-result-to-clipboard-btn').on('click', async (e) => {
                const btn = $(e.target);
                const wrapper = btn.closest('.prompt-input-wrapper');
                let promptResult = wrapper.find('.prompt-result ul');
                if (promptResult.length === 0) {
                    promptResult = wrapper.find('.prompt-result');
                }
                await real.copyToClipboard(promptResult, () => {
                    real.notification.show(howspace.translate('discussion_ai_response_copied_to_clipboard'), 'success');
                }, () => {
                    real.notification.show(howspace.translate('discussion_ai_response_copy_to_clipboard_failed'), 'danger');
                });
            });

            widget.find('.copy-result-to-comment-btn').on('click', () => {
                let promptResult = widget.find('.prompt-result').html();
                const commentEditor = widget.find('.comment-input .howspace-simple-text-editor').first();

                // Replace all h elements in the prompt result with divs.
                promptResult = promptResult.replace(/<h[1-6]>/g, '<div>').replace(/<\/h[1-6]>/g, '</div><br>');
                // Remove repetitive new lines.
                promptResult = promptResult.replace(/(<br\s*\/?>\s*(?:&nbsp;|\s)*){2,}/gi, '<br>');

                // If the editor is not empty, add a new line and the prompt result.
                if (howspace.components.simpleTextEditor.hasContent(commentEditor)) {
                    howspace.components.simpleTextEditor.setContent(commentEditor, howspace.components.simpleTextEditor.getContent(commentEditor) + '<div><br></div>' + promptResult);
                } else {
                    howspace.components.simpleTextEditor.setContent(commentEditor, promptResult);
                }

                // Show the AI-assisted badge.
                widget.find('.comment-input').find('.badge-ai-assisted').removeClass('d-none');

                // If the comment input is in collapsed category, expand it.
                const collapsedCategory = commentEditor.closest('.comment-category.collapsed');
                howspace.commentsTrait.setUncategorizedCommentsCollapsed(collapsedCategory, false);
            });

            widget.find('.generate-poll-btn').on('click', (e) => {
                const btn = $(e.target);
                howspace.aiGen.promptGenerateWidget(
                    $(e.target),
                    widget,
                    'poll',
                    widget.find('.prompt-result').html(),
                    btn.data('use-widget-data-in-gen-prompt') ?? false
                );
            });

            widget.find('.generate-pulse-btn').on('click', (e) => {
                const btn = $(e.target);
                howspace.aiGen.promptGenerateWidget(
                    $(e.target),
                    widget,
                    'pulse',
                    widget.find('.prompt-result').html(),
                    btn.data('use-widget-data-in-gen-prompt') ?? false
                );
            });

            widget.find('.generate-priority-btn').on('click', (e) => {
                const btn = $(e.target);
                howspace.aiGen.promptGenerateWidget(
                    $(e.target),
                    widget,
                    'priority',
                    widget.find('.prompt-result').html(),
                    btn.data('use-widget-data-in-gen-prompt') ?? false
                );
            });

            widget.find('.generate-allocate-btn').on('click', (e) => {
                const btn = $(e.target);
                howspace.aiGen.promptGenerateWidget(
                    $(e.target),
                    widget,
                    'allocate',
                    widget.find('.prompt-result').html(),
                    btn.data('use-widget-data-in-gen-prompt') ?? false
                );
            });
            widget.on('click', '.close-prompt-response-btn', () => {
                widget.find('.prompt-widget-btn').trigger('click');
            });

            // End prompting.

            const checkUncategorizedComments = () => {
                if (!widget.data('is-categorized')) {
                    return;
                }

                howspace.commentsTrait.checkUncategorizedComments(widget);
            };

            return new Promise((resolve) => {
                const commentsListers = widget.find('.comments.howspace-lister');
                let waitingForListersCount = commentsListers.length;

                if (waitingForListersCount === 0) {
                    resolve();
                    return;
                }

                widget.find('.comment-category.uncategorized .comments.howspace-lister').one(howspace.components.lister.LIST_ITEMS_LOADED, checkUncategorizedComments);

                commentsListers.each((_i, lister) => {
                    lister = $(lister);
                    if (widget.data('is-categorized')) {
                        // Always show cards in categorized mode, never the "no items" container.
                        // This helps to move a comment from one category to another empty one.
                        lister.on(howspace.components.lister.LIST_ITEMS_RENDERED, () => {
                            lister.removeClass('no-items');
                            lister.find('.howspace-lister-no-items').addClass('d-none').css({display: '', opacity: ''});
                            lister.find('.howspace-lister-cards').removeClass('d-none').css({display: '', opacity: ''});
                        });
                    }
                    lister.one(howspace.components.lister.LIST_ITEMS_RENDERED, () => {
                        waitingForListersCount--;
                        if (waitingForListersCount === 0) {
                            resolve();
                        }
                    });
                });
            });
        },
        destroyView: widget => {
            howspace.whatsNew.destroy(widget);
            howspace.commentsTrait.destroyComponentHandlers(widget);
            howspace.aiGen.clearPromptTimeout(widget);
        },
        initEdit: widget => {
            widget.find('.add-category-btn').on('click', e => {
                const sortableList = widget.find('.howspace-sortable-list');
                const category = howspace.components.sortableList.addItem(sortableList);
                const color = categoryColorForPosition(e.currentTarget, sortableList.find('.category').length - 1);
                howspace.components.colorPicker.setColor(category.find('.howspace-color-picker'), color);
            });

            widget.find('input[data-name="super_chat_mode"]').on('change', () => {
                checkMode(widget);
            });

            checkMode(widget);
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            switch (widget.find('input[data-name="super_chat_mode"]:checked').val()) {
                case 'super_chat':
                    dataPayload.is_sticky_notes = false;
                    dataPayload.is_categorized = false;
                    dataPayload.subtype = null;
                    break;

                case 'sticky_notes':
                    dataPayload.is_sticky_notes = true;
                    dataPayload.is_categorized = false;
                    dataPayload.subtype = 'sticky_notes';
                    break;

                case 'kanban':
                    dataPayload.is_sticky_notes = true;
                    dataPayload.is_categorized = true;
                    dataPayload.subtype = 'kanban';
                    break;
            }

            // Reverse the polarity on the flux capacitor.
            // This could be renamed to "show_comment_and_reply_authors" to avoid this reversal.
            dataPayload.hide_comment_and_reply_authors = !dataPayload.hide_comment_and_reply_authors;

            // Decode the compound sort_by radio value (original_desc / original_asc) into
            // separate sort_by and sort_order fields for the API.
            const rawSortBy = dataPayload.sort_by;
            if (rawSortBy === 'original_desc') {
                dataPayload.sort_by = 'original';
                dataPayload.sort_order = 'desc';
            } else if (rawSortBy === 'original_asc') {
                dataPayload.sort_by = 'original';
                dataPayload.sort_order = 'asc';
            } else {
                // Non-original sorts (likes, points, reactions) are always descending.
                dataPayload.sort_order = 'desc';
            }

            if (!widget.hasClass('widget-parallel')) {
                dataPayload.categories = [];
                widget.find('.category:not(.deleted)').each(function () {
                    dataPayload.categories.push(real.form.getDataPayload($(this)));
                });
            }

            // What can see
            switch (widget.find('.can-see-radio:checked').val()) {
                case 'own':
                    dataPayload.user_can_see_only_own_comments = true;
                    dataPayload.user_can_see_only_team_comments = false;
                    dataPayload.user_can_see_only_userlist_comments = false;
                    dataPayload.user_can_see_comments_before_has_given_comment = true;
                    break;
                case 'team':
                    dataPayload.user_can_see_only_own_comments = false;
                    dataPayload.user_can_see_only_team_comments = true;
                    dataPayload.user_can_see_only_userlist_comments = false;
                    dataPayload.user_can_see_comments_before_has_given_comment = true;
                    break;
                case 'userlist':
                    dataPayload.user_can_see_only_own_comments = false;
                    dataPayload.user_can_see_only_team_comments = false;
                    dataPayload.user_can_see_only_userlist_comments = true;
                    dataPayload.user_can_see_comments_before_has_given_comment = true;
                    break;
                case 'all-after-commenting':
                    dataPayload.user_can_see_only_own_comments = false;
                    dataPayload.user_can_see_only_team_comments = false;
                    dataPayload.user_can_see_only_userlist_comments = false;
                    dataPayload.user_can_see_comments_before_has_given_comment = false;
                    break;
                case 'all':
                    dataPayload.user_can_see_only_own_comments = false;
                    dataPayload.user_can_see_only_team_comments = false;
                    dataPayload.user_can_see_only_userlist_comments = false;
                    dataPayload.user_can_see_comments_before_has_given_comment = true;
                    break;
            }

            dataPayload.all_participants_can_comment = dataPayload.all_participants_can_comment || false;
            dataPayload.all_teams_can_comment = dataPayload.all_teams_can_comment || false;
            dataPayload.all_participants_can_reply = dataPayload.all_participants_can_reply || false;
            dataPayload.all_teams_can_reply = dataPayload.all_teams_can_reply || false;

            return dataPayload;
        },
        updateFilter: howspace.commentsTrait.reloadComments,
        initPromptResponseFeedbackModal: initPromptResponseFeedbackModal,
        initUsersWhoHaveCommentedModal: initUsersWhoHaveCommentedModal,
        initUsersWhoHaveNotCommentedModal: initUsersWhoHaveNotCommentedModal,
        initAddCategoryModal: initAddCategoryModal,
        initAiCategorizeModal: initAiCategorizeModal,
        initAutoGenerateContentModal: initAutoGenerateContentModal,
    };
})();
